@if (state() === 'active') {
<div
  class="flex items-center justify-between gap-3 w-full sm:max-w-[340px] rounded-md border-1 border-gray-300 border-b-4 {{ borderColor }} p-3 mt-3 mx-auto shadow-lg bg-white dark:bg-[#1E2634]"
>
  <div class="flex items-center gap-4">
    <!-- Icon -->
    <div class="flex items-center justify-center w-10 h-10 rounded-lg" [ngClass]="iconBg" [innerHTML]="icon | safeHtml">
    </div>
    <!-- Title and Description -->
    <div>
      @if(title()) {
      <h4 class="text-sm text-gray-800 sm:text-base dark:text-white/90">
        {{ title() }}
      </h4>
      }
      @if (message()) {
      <p class="mt-1 text-xs text-gray-600 sm:text-sm dark:text-white/70">
        {{ message() }}
      </p>
      }
    </div>
  </div>
  <!-- Close Button -->
  @if (options().closeButton) {
  <div class="flex items-center">
    <button type="button"
      (click)="remove()"
      class="text-gray-400 hover:text-gray-800 dark:hover:text-white/90 pointer-events-auto">
      <svg class="size-6" width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.04289 16.5418C5.65237 16.9323 5.65237 17.5655 6.04289 17.956C6.43342 18.3465 7.06658 18.3465 7.45711 17.956L11.9987 13.4144L16.5408 17.9565C16.9313 18.347 17.5645 18.347 17.955 17.9565C18.3455 17.566 18.3455 16.9328 17.955 16.5423L13.4129 12.0002L17.955 7.45808C18.3455 7.06756 18.3455 6.43439 17.955 6.04387C17.5645 5.65335 16.9313 5.65335 16.5408 6.04387L11.9987 10.586L7.45711 6.04439C7.06658 5.65386 6.43342 5.65386 6.04289 6.04439C5.65237 6.43491 5.65237 7.06808 6.04289 7.4586L10.5845 12.0002L6.04289 16.5418Z" fill="currentColor"></path></svg>
    </button>
  </div>
  }
</div>
}